// extracted by mini-css-extract-plugin
export default {"rating":"uO-z","numberOfStars":"vO-z","count":"wO-z","barGraphSpacing":"xO-z","barGraph":"yO-z"};